import React, { memo } from 'react';
import { Icon } from '@surveycake/rc';
import { redoOutlined } from '@surveycake/rc';
import { useStyles } from './styles';

export interface ClearProps {
  label: string;
  onClear: () => void;
}

function Clear({ label, onClear }: ClearProps) {
  const styles = useStyles();

  return (
    <div className={styles.clearContainer}>
      <div className={styles.clear} onClick={onClear}>
        <span>{label}</span>
        <Icon className={styles.clearIcon} icon={redoOutlined} />
      </div>
    </div>
  );
}

export default memo(Clear);
